<template>
  <span href="javascript:void(0)" @click="onClick" style="cursor:pointer;">
    <u>{{ data.titulo }}</u>
  </span>
</template>
<script>
export default {
  name: "search-partials-compliance",
  methods: {
    onClick() {
      const d = this.data;
      Vue.prototype.$eventHub.$emit(
        "toggleSidebarClick",
        d.titulo,
        "processes-detail-process-task-rule-detail",
        d
      );
    }
  }
};
</script>